import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import { ApiFilledAptitudeTestSectionResponse }
  from 'src/services/entity-factory/factories/FilledAptitudeTestSectionFactory';

export interface ApiFilledAptitudeTestResponse {
  test: {
    id: number;
    testId: number;
    passed: boolean;
    sections: ApiFilledAptitudeTestSectionResponse[];
  };
}

interface ApiFilledAptitudeTestCreateRequest {
}

export class FilledAptitudeTestFactory extends BaseFactory<FilledAptitudeTest> {
  public toEntity(args: ApiFilledAptitudeTestResponse): FilledAptitudeTest {
    return new FilledAptitudeTest({
      id: args.test.id,
      testId: args.test.testId,
      passed: args.test.passed,
      sections: args.test.sections ?
          args.test.sections.map(
            (section) => this.entityFactoryFactory.filledAptitudeTestSectionFactory.toEntity(section)
          ) : [],
    });
  }

  public toRequest(filledAptitudeTest: FilledAptitudeTest): ApiFilledAptitudeTestCreateRequest {
    return filledAptitudeTest;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/FilledAptitudeTestFactory.tsx